import React from "react";

import client1 from "../assets/client1.png";
import client2 from "../assets/client2.png";
import client3 from "../assets/client3.png";
import client4 from "../assets/client4.png";
import client5 from "../assets/client5.png";
import client6 from "../assets/client6.png";
import client7 from "../assets/client7.png";

const CLIENTS = [
  { img: client1, name: "AAA Pharmaceuticals" },
  { img: client2, name: "DU Global" },
  { img: client3, name: "DPAL" },
  { img: client4, name: "Green Valley" },
  { img: client5, name: "Harmony Holdings" },
  { img: client6, name: "MetaEdge" },
  { img: client7, name: "SAT Enterprises" },
];

function TrustedSlider() {
  const doubled = [...CLIENTS, ...CLIENTS];

  return (
    <section className="trusted-strip">
      <div className="trusted-inner">
        <div className="trusted-label">
          <span>Trusted by</span>
          <strong>Top Companies</strong>
        </div>

        <div className="trusted-track-wrap">
          <div className="trusted-track">
            {doubled.map((client, i) => (
              <div className="trusted-logo" key={`${client.name}-${i}`}>
                <img src={client.img} alt={client.name} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default TrustedSlider;
